'use strict';
import React from 'react';

import CircularProgress from "@material-ui/core/CircularProgress";
import PropTypes from "prop-types";
import {ColorNegative, ColorSubTitle} from "../../../styles/Colors";
import {baseStyles, withMultipleStyles} from "../../../styles/Styles";
import {Box, Button, Card, Typography} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import {DropzoneArea} from "material-ui-dropzone";
import {InsertPhotoOutlined} from "@material-ui/icons";
import FormHelperText from "@material-ui/core/FormHelperText";
import Cropper from 'react-easy-crop';
import DialogTitle from "@material-ui/core/DialogTitle";
import {FormattedMessage} from "react-intl";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import {getCroppedImg} from "../../utils/canvasUtils";
import imageCompression from 'browser-image-compression';

const useStyles = (theme) => ({
  dropzoneBox: {
    padding: theme.spacing(1.5),
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    width: '100%',
    '&:hover': {
      borderColor: ColorSubTitle,
    },
  },
  dropZoneContainer: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    flexDirection: 'row',
    minHeight: 50,
  },
  dropZone: {
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(1),
    height: 50,
    alignItems: 'center',
    justifyContent: 'center',
  },
  dropZoneText: {
    fontSize: 14,
    marginBottom: 4,
    opacity: 0.5,
  },
  previewContainer: {
    container: true,
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    paddingTop: 4,
    paddingBottom: 0,
    marginTop: 1,
    marginLeft: 1,
    marginRight: 1,
    marginBottom: 1,
  },
  previewImgContainer: {
    padding: 0,
    height: 68,
    minWidth: 118,
    maxWidth: 118,
    item: true,
    backgroundColor: '#FAFAFA',
    borderRadius: 4,
    borderWidth: 4,
    marginTop: 4,
    marginBottom: 0,
    marginLeft: 4,
    marginRight: 4,
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    // position: 'relative',
    zIndex: 10,
    // textAlign: 'center',
    '&:hover $previewImg': {
      opacity: 0.3
    },
    '&:hover $removeButton': {
      opacity: 1
    }
  },
  previewImg: {
    height: 64,
    width: 64,
    minWidth: 64,
    maxWidth: '100%',
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    boxSizing: 'border-box',
    boxShadow: 'rgba(0, 0, 0, 0.12) 0 1px 6px, rgba(0, 0, 0, 0.12) 0 1px 4px',
    borderRadius: 4,
    zIndex: 5,
    opacity: 1,
    objectFit: 'contain'
  },
  previewVideoContainer: {
    padding: 0,
    height: 156,
    minWidth: 300,
    maxWidth: 300,
    item: true,
    backgroundColor: '#FAFAFA',
    borderRadius: 4,
    borderWidth: 4,
    marginTop: 4,
    marginBottom: 0,
    marginLeft: 4,
    marginRight: 4,
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    // position: 'relative',
    zIndex: 10,
    // textAlign: 'center',
    '&:hover $previewImg': {
      opacity: 0.3
    },
    '&:hover $removeButton': {
      opacity: 1
    }
  },
  previewVideo: {
    height: 148,
    width: 260,
    minWidth: 260,
    maxWidth: '100%',
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    boxSizing: 'border-box',
    boxShadow: 'rgba(0, 0, 0, 0.12) 0 1px 6px, rgba(0, 0, 0, 0.12) 0 1px 4px',
    borderRadius: 4,
    zIndex: 5,
    opacity: 1,
    objectFit: 'contain'
  },
  previewAudioContainer: {
    padding: 0,
    height: 44,
    minWidth: 368,
    maxWidth: 368,
    item: true,
    backgroundColor: '#FAFAFA',
    borderRadius: 4,
    borderWidth: 4,
    marginTop: 4,
    marginBottom: 0,
    marginLeft: 4,
    marginRight: 4,
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    // position: 'relative',
    zIndex: 10,
    textAlign: 'center',
    '&:hover $previewAudio': {
      opacity: 0.3
    },
    '&:hover $removeButton': {
      opacity: 1
    }
  },
  previewAudio: {
    height: 40,
    width: 360,
    minWidth: 360,
    maxWidth: '100%',
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    boxShadow: 'rgba(0, 0, 0, 0.12) 0 1px 6px, rgba(0, 0, 0, 0.12) 0 1px 4px',
    borderRadius: 4,
    zIndex: 5,
    opacity: 1
  },
  previewFile: {
    height: 80,
    width: 60,
    minWidth: 60,
    maxWidth: '100%',
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    boxShadow: 'rgba(0, 0, 0, 0.12) 0 1px 6px, rgba(0, 0, 0, 0.12) 0 1px 4px',
    borderRadius: 4,
    zIndex: 5,
    opacity: 1
  },
  dropIcon: {
    opacity: 0.5,
    width: 40,
    height: 0,
  },
  progressContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: theme.spacing(1)
  },
});

let counter = 0;

export const IMAGE_MAX_SIZE = 30*1024*1024;
export const IMAGE_MAX_WIDTH_HEIGHT = 1280;
export const IMAGE_PROFILE_MAX_WIDTH_HEIGHT = 640;

class FilePicker extends React.Component {

  constructor(props) {
    super(props);

    const initialFiles = this.processInitialFiles(this.props.initialFiles);
    this.state = {
      key: 0,
      newImageFile: null,
      initialFiles: initialFiles,
      isLoading: initialFiles.length > 0,
      isImageProcessing: false,
      crop: {x: 0, y: 0},
      zoom: 1,
    }
  }

  render() {
    const {classes, acceptedFiles, label, required, filesLimit, maxFileSize, aspectRatio, error, errorText, showPreviews, showPreviewsInDropzone, helperText, onChange, onDelete} = this.props;

    const eAspectRatio = aspectRatio || 16/9;
    const limit = filesLimit || 1;
    const eShowPreviews = showPreviews || true;
    const eShowPreviewsInDropzone = showPreviewsInDropzone || false;

    let classPreviewContainer = null;
    let classPreview = null;
    if (acceptedFiles && acceptedFiles.length > 0) {
      if (acceptedFiles[0].split('/')[0] === 'image') {
        classPreviewContainer = classes.previewImgContainer;
        classPreview = classes.previewImg;
      } else if (acceptedFiles[0].split('/')[0] === 'audio') {
        classPreviewContainer = classes.previewAudioContainer;
        classPreview = classes.previewAudio;
      } else if (acceptedFiles[0].split('/')[0] === 'video') {
        classPreviewContainer = classes.previewVideoContainer;
        classPreview = classes.previewVideo;
      } else {
        classPreviewContainer = classes.previewImgContainer;
        classPreview = classes.previewImg;
      }
    }

    return (
      <div style={{width: '100%'}}>
        <Box border={1} borderColor={error ? ColorNegative : "grey.400"} borderRadius={4} className={classes.dropzoneBox}>
          <InputLabel required={required}>{label}</InputLabel>
          <DropzoneArea
            key={''+ this.state.key}
            ref={(ref) => this.refDropZone = ref}
            style={{display: 'flex', flexDirection: 'row'}}
            dropzoneClass={classes.dropZoneContainer}
            classes={{root: classes.dropZone, text: classes.dropZoneText, icon: classes.dropIcon}}
            initialFiles={this.state.initialFiles}
            dropzoneProps={{disabled: false}}
            acceptedFiles={acceptedFiles}
            filesLimit={limit}
            clearOnUnmount={true}
            maxFileSize={maxFileSize}
            dropzoneText={this.context.intl.formatMessage({id: 'generic.dragDropClickImage'})}
            previewText={''}
            showPreviewsInDropzone={eShowPreviewsInDropzone}
            showPreviews={eShowPreviews}
            showFileNames={false}
            previewGridClasses={{
              container: classes.previewContainer,
              item: classPreviewContainer,
              image: classPreview,
            }}
            Icon={InsertPhotoOutlined}
            showAlerts={['error']}
            getFileLimitExceedMessage={(filesLimit) => {
              return this.context.intl.formatMessage({id: 'filePicker.fileLimitExceedMessage'}, {value: filesLimit});
            }}
            getFileAddedMessage={(fileName) => {
              return this.context.intl.formatMessage({id: 'filePicker.fileAddedMessage'}, {value: fileName});
            }}
            getFileRemovedMessage={(fileName) => {
              return this.context.intl.formatMessage({id: 'filePicker.fileRemovedMessage'}, {value: fileName});
            }}
            getDropRejectMessage={(rejectedFile, acceptedFiles, maxFileSize) => {
              let message = this.context.intl.formatMessage({id: 'filePicker.fileDropRejectMessage'}, {value: rejectedFile.name});
              if (!acceptedFiles.includes(rejectedFile.type)) {
                message += this.context.intl.formatMessage({id: 'filePicker.fileNotSupported'});
              }
              if (rejectedFile.size > maxFileSize) {
                message += this.context.intl.formatMessage({id: 'filePicker.fileTooBig'}, {value: this.convertBytesToMbsOrKbs(maxFileSize)});
              }
              return message;
            }}
            getPreviewIcon={(file) => {
              if (file.file.type.split('/')[0] === 'image') {
                return (
                  <img className={classes.previewImg} role="presentation" src={file.data} height={64} width={114} />
                );
              } else if (file.file.type.split('/')[0] === 'audio') {
                return (
                  <audio className={classes.previewAudio} controls role="presentation">
                    <source src={file.data} type="audio/mpeg" />
                  </audio>
                );
              } else {
                return (
                  <img className={classes.previewImg} role="presentation" src={'./images/ic_file.png'} />
                );
              }
            }}
            onDrop={(files) => {
              if (files && files.length > 0 && files[files.length - 1].type.split('/')[0] === 'image') {
                this.onFilePicked(files[files.length - 1]);
              } else {
                this.setState({newImageFile: null});
              }
            }}
            onDelete={(file) => {
              onDelete(file);
            }}
            onChange={(files) => {
              if (files && files.length > 0 && files[files.length - 1].type.split('/')[0] === 'image') {
                this.setState({isLoading: false});
              } else {
                onChange(files);
                this.setState({isLoading: false});
              }
            }}
          />
          {this.state.isLoading && (
            <div className={classes.progressContainer}>
              <CircularProgress size={20}/>
            </div>
          )}
        </Box>
        {helperText && <FormHelperText className={classes.helper}>{helperText}</FormHelperText>}
        {errorText && <FormHelperText className={classes.helperError}>{errorText}</FormHelperText>}

        {this.state.newImageFile ?
          <Dialog disableBackdropClick onClose={this.onDialogClose} aria-labelledby="customized-dialog-title" open={open}>
            <DialogTitle>
              <Typography color={"primary"} variant="h6" align="center">
                <FormattedMessage id={'Resize Image'} />
              </Typography>
            </DialogTitle>
            <DialogContent>
              <div style={{width: Math.min(window.appWidth, 800), height: Math.min(window.appHeight, 600)}}>
                <Cropper
                  style={{
                    containerStyle: {position: 'absolute', top: 66, bottom: 60, left: 2, right: 2, borderRadius: 4},
                  }}
                  image={this.state.newImageFile}
                  crop={this.state.crop}
                  zoom={this.state.zoom}
                  aspect={eAspectRatio}
                  onCropChange={(crop) => {
                    this.setState({crop});
                  }}
                  onCropComplete={(croppedArea, croppedAreaPixels) => {
                    // console.log(croppedAreaPixels);
                    this.setState({croppedAreaPixels: croppedAreaPixels});
                  }}
                  onZoomChange={(zoom) => {
                    this.setState({ zoom })
                  }}
                />
                {this.state.isImageProcessing &&
                <div style={{display: 'flex', position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, alignItems: 'center', justifyContent: 'center'}}>
                  <Card style={{width: 80, height: 80, alignItems: 'center', justifyContent: 'center', display: 'flex', borderRadius: 8, opacity: 0.95}}>
                    <CircularProgress />
                  </Card>
                </div>
                }
              </div>
            </DialogContent>
            <DialogActions>
              <div className={classes.dialogActionsViewOutline}>
                <Button
                  color="primary"
                  variant={'outlined'}
                  onClick={() => {
                    this.setState({newImageFile: null, key: this.state.key + 1});
                  }}>
                  <FormattedMessage id={'generic.no'} />
                </Button>
                <Button
                  disableElevation
                  color="primary"
                  variant={'contained'}
                  onClick={() => {
                    this.setState({isImageProcessing: true}, () => {
                      this.processImageFile();
                    });
                  }}>
                  <FormattedMessage id={'generic.yes'} />
                </Button>
              </div>
            </DialogActions>
          </Dialog>
          : null
        }
      </div>
    );
  }

  processInitialFiles(files) {
    const initialFiles = [];
    if (files && files.length > 0) {
      files.forEach((file) => {
        console.log('initialFile', files);
        // eslint-disable-next-line no-prototype-builtins
        if (file instanceof File && file.hasOwnProperty('tempData') && file.tempData) {
          initialFiles.push(file.tempData);
        } else {
          initialFiles.push(file);
        }
      });
    }
    return initialFiles;
  }

  async onFilePicked(file) {
    const newImageFile = await this.readFile(file);
    this.setState({isLoading: false, newImageFile: newImageFile, crop: {x: 0, y: 0}, zoom: 1});
  }

  async processImageFile() {
    const {initialFiles, filesLimit, maxWidthOrHeight, onChange} = this.props;
    const limit = filesLimit || 1;
    try {
      const croppedImage = await getCroppedImg(this.state.newImageFile, this.state.croppedAreaPixels);
      const compressedImage = await imageCompression(croppedImage, {
        maxSizeMB: 2,
        maxWidthOrHeight: maxWidthOrHeight || IMAGE_MAX_WIDTH_HEIGHT,
        initialQuality: 0.8,
      });

      const finalImage = new File([compressedImage], 'TempRab7B_'+ (++counter) +'.jpg');
      finalImage.tempData = compressedImage;
      // console.log('FinalImage', finalImage);
      // console.log('FinalImageSize', `${compressedImage.size / 1024 } KB`);

      let changedFiles = null;
      if (limit > 1) {
        changedFiles = initialFiles;
        if (changedFiles) {
          changedFiles.push(finalImage);
        } else {
          changedFiles = [finalImage];
        }
      } else {
        changedFiles = [finalImage];
      }

      const newInitialFiles = this.processInitialFiles(changedFiles);
      this.setState({isImageProcessing: false, newImageFile: null, initialFiles: newInitialFiles, key: this.state.key + 1}, () => {
        onChange(changedFiles);
      });
    } catch (e) {
      // console.error(e);
      this.setState({isImageProcessing: false, newImageFile: null, key: this.state.key + 1});
    }
  }

  readFile(file) {
    return new Promise((resolve) => {
      const reader = new FileReader()
      reader.addEventListener('load', () => resolve(reader.result), false)
      reader.readAsDataURL(file)
    });
  }

  convertBytesToMbsOrKbs(filesize) {
    let size = '';

    if (filesize >= 1048576) {
      size = filesize / 1048576 + ' MB';
    } else if (filesize >= 1024) {
      size = filesize / 1024 + ' KB';
    } else {
      size = filesize + ' B';
    }

    return size;
  }
}

FilePicker.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string,
  highlighted: PropTypes.bool,
  required: PropTypes.bool,
  maxFileSize: PropTypes.number,
  maxWidthOrHeight: PropTypes.number,
  acceptedFiles: PropTypes.array,
  filesLimit: PropTypes.number,
  aspectRatio: PropTypes.number,
  showPreviews: PropTypes.bool,
  showPreviewsInDropzone: PropTypes.bool,
  initialFiles: PropTypes.array,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  helperText: PropTypes.string,
  onChange: PropTypes.func,
  onDelete: PropTypes.func,
}

FilePicker.contextTypes = {
  intl:PropTypes.object.isRequired
}

export default withMultipleStyles(baseStyles, useStyles)(FilePicker);
